<div class="dis-flex">
  <img [style.width.%]="imageWidth" class="m-l-r-auto" src="{{ env.assetUrl }}/no_data_found.png" />
</div>
